import { render, staticRenderFns } from "./selectgoods.vue?vue&type=template&id=4dd2aabd&scoped=true"
import script from "./selectgoods.vue?vue&type=script&lang=js"
export * from "./selectgoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2aabd",
  null
  
)

export default component.exports